import type * as React from "react";
import { useServerSideContent } from "../hooks/useServerSideContent";
import { memo } from "react";
import RenderServerSideContent from "./RenderServerSideContent";
import { useEffect } from "react";

interface Props {
  selector: string;
  className?: string;
  transformNode?: (node: Element) => void;
}

const SimpeRenderServerSideContent: React.FC<Props> = ({ selector, className, transformNode }) => {
  const { element } = useServerSideContent(selector);

  useEffect(() => {
    if (element && transformNode) {
      transformNode(element);
    }
  }, [transformNode, element]);

  if (!element) {
    return null;
  }

  return <RenderServerSideContent className={className} content={element} />;
};

export default memo(SimpeRenderServerSideContent);
